import React from "react";
import ErrorField from "./error";
import { TextField } from "components/support";
import { observer } from "mobx-react";

const BarcodeField = ({ errors, row, onChange }) => {
  const { barcode } = row;
  const foundErrors = errors.find(v => v.name === row.name);
  const hasErrors =
    foundErrors && !!foundErrors.errors && !!foundErrors.errors.barcode;

  return (
    <div>
      <TextField
        value={barcode}
        onChange={(_, value) => onChange(value.replace(/[^A-Z0-9]/gi, ""))}
        fullWidth
      />
      {hasErrors && <ErrorField error={foundErrors.errors.barcode} />}
    </div>
  );
};

export default observer(BarcodeField);



// WEBPACK FOOTER //
// ./src/components/app/registration/product/batch/fields/barcode.js